import React from 'react';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import Grade from 'shared/img/education-onboarding/grade.svg';
import styles from '../Resume/styles.module.scss';

const EarnScholarships = () => (
  <BaseStep
    stepHeader={
      <>
        <Grade className={styles.icon} width={121} />
        Earn awards by completing activities
      </>
    }
    subHeader={
      <>
        Earn awards by completing activities by their deadline and
        <br />
        adding them to your Raise Me account.
      </>
    }
  />
);

export default EarnScholarships;
